import { render, staticRenderFns } from "./ModalLinkBranch.vue?vue&type=template&id=32059b82&scoped=true&"
import script from "./ModalLinkBranch.vue?vue&type=script&lang=ts&"
export * from "./ModalLinkBranch.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLinkBranch.vue?vue&type=style&index=0&id=32059b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32059b82",
  null
  
)

export default component.exports